export default __webpack_public_path__ + "static/media/questionmark-icon.af14c38b.png";